import React from 'react';
import Select from 'react-select';
import styled from 'styled-components';
import Error from '../elements/renderError';

const Wrapper = styled.div`
  text-align: center;
  margin-top: 30px;
`;

// This handler is necessary so that the select component with redux form works on mobile browsers
const handleBlur = input => {
  setTimeout(() => {
    input.onBlur(input.value);
  }, 1);
};

export const FormSelect = props => {
  const { input, options, meta } = props;

  return (
    <Wrapper>
      <Select
        {...input}
        onChange={value => input.onChange(value)}
        onBlur={handleBlur(input)}
        options={options}
        placeholder={'Select'}
      />{' '}
      &nbsp;&nbsp;&nbsp;
      <Error meta={meta} errorHeight={30} />
    </Wrapper>
  );
};

export default FormSelect;
